module.exports = __webpack_public_path__ + "./img/spinner-rotate.976a4e667f9363dbcb86375ba5f5f900.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner-rotate.gif
// module id = ./src/assets/spinner-rotate.gif
// module chunks = 0